import React from 'react'
import { ServiceContentModel } from '../../../../types/services/serviceModel'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../../styles'
import { FormattedMessage } from 'react-intl'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination } from 'swiper'
import ServiceItem from '../ServiceItem'
import 'swiper/components/pagination/pagination.scss'
import { useMediaQuery } from 'react-responsive'

SwiperCore.use([Pagination])

const useStyle = makeStyles(
	(theme) => (
		{
			...styles(theme),
			carouselStyle: {
				marginTop: 100,

				'& h1': {
					marginBottom: 50,
					...styles(theme).title2,
					color: theme.palette.blue.main
				},
				'& .swiper-container-autoheight': {
					paddingBottom: 50,

					'& .swiper-pagination-bullet': {
						width: 15,
						height: 15
					},
					'& .swiper-pagination-bullet-active': {
						backgroundColor: theme.palette.blue.main
					}
				}
			}
		}
	)
)

interface AcceptingProps {
	services: ServiceContentModel[]
}

type ServiceCarouselProps = AcceptingProps

const ServiceCarousel: React.FC<ServiceCarouselProps> = (
	{
		services
	}
) => {
	const classes = useStyle()

	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	return (
		<div className={classes.carouselStyle}>
			<h1>
				<FormattedMessage
					id="services.details.title"
					defaultMessage="Les autres services YouFirst"
					description="Carousel title"
				/>
			</h1>

			{
				services.length > 2 ? (
					<Swiper
						autoHeight
						loop
						spaceBetween={16}
						slidesPerView={isLargeScreen ? 2 : 1}
						pagination={{ clickable: true }}
					>
						{
							services.map(
								(service) => (
									<SwiperSlide key={service.id}>
										<ServiceItem service={service} />
									</SwiperSlide>
								)
							)
						}
					</Swiper>
				) : (
					<div className="row">
						{
							services.map(
								(service) => (
									<div
										className="col-xs-12 col-md-6"
										key={service.id}
									>
										<ServiceItem service={service} />
									</div>
								)
							)
						}
					</div>
				)
			}

		</div>
	)
}

export default ServiceCarousel
